export default __webpack_public_path__ + "static/media/third-step-cg-create-plwd.af98c479.png";